export const postClassNames =
  "prose-blue prose lg:prose-lg focus:outline-none h-full w-full max-w-[846px] mx-auto dark:prose-invert"
